import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-playlist-menu',
  templateUrl: './playlist-menu.component.html',
  styleUrls: ['./playlist-menu.component.scss']
})
export class PlaylistMenuComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
